'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _section = require('./section');

var _section2 = _interopRequireDefault(_section);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setInterval = require('common/utils/set-interval');

var _setInterval2 = _interopRequireDefault(_setInterval);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ApiMenu = _react2['default'].createClass({
    displayName: 'ApiMenu',


    propTypes: {
        sections: _react2['default'].PropTypes.array.isRequired, // A list of objects formatted as { title, url, reference, items: [{ title, reference, url, subItems: [{ title, reference, url }] }] }
        initiallyActiveSection: _react2['default'].PropTypes.string, // Reference of the section intially active
        initiallyActiveItem: _react2['default'].PropTypes.string, // Reference of the section item initially active
        initiallyActiveSubItem: _react2['default'].PropTypes.string, // Reference of the section sub item initially active
        isInitiallyCollapsed: _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'isInitiallyCollapsed': false
        };
    },

    getInitialState: function getInitialState() {
        return {
            isFixed: false,
            isCollapsed: this.props.isInitiallyCollapsed,
            activeSection: this.props.initiallyActiveSection,
            activeItem: this.props.initiallyActiveItem,
            activeSubItem: this.props.initiallyActiveSubItem
        };
    },

    stickMenu: function stickMenu(menu) {
        this.setState({
            'isFixed': true
        });
    },

    unstickMenu: function unstickMenu(menu) {
        this.setState({
            'isFixed': false
        });
    },

    startHashSpy: function startHashSpy(interval) {

        var self = this;

        // NOTE: Initialize to null so we detect a 'changed' event right after loading the page
        this.__hash = null;
        this.__ref = null;

        var getSelectionFromRef = function getSelectionFromRef(ref) {
            var selection = {
                'activeSection': undefined,
                'activeItem': undefined,
                'activeSubItem': undefined
            };

            var s;
            var i;
            var j;
            var k;
            for (i = 0; i < self.props.sections.length; i++) {
                s = self.props.sections[i];

                // Try to match a section
                if (s.reference.toLowerCase() == ref) {
                    selection.activeSection = ref;
                }

                // Try to match a section item
                if (!selection.activeSection && s.items && s.items.length > 0) {
                    for (j = 0; j < s.items.length; j++) {
                        if (s.items[j].reference.toLowerCase() == ref) {
                            selection.activeSection = s.reference;
                            selection.activeItem = ref;
                            break;
                        }
                    }
                }

                // Try to match a sub item if nothing else matched
                if (!selection.activeSection) {
                    for (j = 0; j < s.items.length; j++) {
                        if (s.items[j].subItems && s.items[j].subItems.length > 0) {
                            for (k = 0; k < s.items[j].subItems.length; k++) {
                                if (s.items[j].subItems[k].reference.toLowerCase() == ref) {
                                    selection.activeSection = s.reference;
                                    selection.activeItem = s.items[j].reference;
                                    selection.activeSubItem = s.items[j].subItems[k].reference;
                                    break;
                                }
                            }
                        }
                        if (selection.activeSection) {
                            break;
                        }
                    }
                }

                // Match found
                if (selection.activeSection) {
                    break;
                }
            }

            // Update menu selection
            if (selection.activeSection) {

                var newStates = _hfReactHelper2['default'].extend(selection, {
                    'isFixed': self.state.isFixed
                });
                self.setState(newStates);
            }
        };

        // Listen for for hash changes
        (0, _setInterval2['default'])(function () {

            var h = document.location.hash;
            if (h != self.__hash) {

                self.__hash = h;

                var path = document.location.pathname.split('/').pop();
                var ref = h ? h.replace('#', '') : path;
                if (!h && path == 'documentation') {
                    ref = 'quickstart';
                } else if (ref) {
                    ref = ref.toLowerCase();
                }

                getSelectionFromRef(ref);
            }
        }, interval);

        // Listen for selection change from scrolling
        $(document).bind('menu_selection_change', function (evt, evtData) {
            if (evtData && evtData.ref && (!this.__ref || evtData.ref != this.__ref)) {
                getSelectionFromRef(evtData.ref.toLowerCase());
                this.__ref = evtData.ref;
            }
        });
    },

    /**
     * If user scrolls down a certain distance, update this.state.isFixed to
     * true. Also, if the window is smaller than the menu, the menu should be
     * fixed, otherwise you the user can't see the whole menu without scrolling
     * all the way down the page.
    */
    startStickinessSpy: function startStickinessSpy(interval) {

        var self = this;
        var lastTopOffset = 0;
        var fixedPadding = 16;
        var fixed = false;
        var menu = $(_reactDom2['default'].findDOMNode(this));

        var el = $(document.body);
        var ua = navigator.userAgent.toLocaleLowerCase();
        if (/firefox/.test(ua) || /msie/.test(ua) || /Windows NT 6.3.*rv\:11\.0/gi.test(ua)) {
            // Special case for FF and IE (scrollTop is defined on html and not body)
            el = $('html');
        }

        (0, _setInterval2['default'])(function () {

            var topOffset = el.scrollTop();

            if (topOffset != lastTopOffset) {

                lastTopOffset = topOffset;
                var menuContainer = $("#api-docs-menu-container");
                var componentHeight = self.refs.apiDocMenu.scrollHeight;
                var windowHeight = window.innerHeight;

                var shouldEnableStick = !fixed && topOffset > menuContainer.offset().top - fixedPadding && windowHeight > componentHeight;

                var shouldDisableStick = fixed && topOffset <= menuContainer.offset().top - fixedPadding;

                if (shouldEnableStick) {
                    self.stickMenu(menu);
                    fixed = true;
                }

                if (shouldDisableStick) {
                    self.unstickMenu(menu);
                    fixed = false;
                }
            }
        }, interval);
    },

    startScrollSpy: function startScrollSpy(interval) {

        var self = this;
        var sections = $('.m-api-docs-section, .m-api-ref-section, .m-api-docs-sub-section[id]');
        var hasRefSections = {};
        var hasSubSections = {};
        var currentSection = null;
        var w = $(window);

        sections.each(function () {
            var el = $(this);
            var ref = el.attr('id');
            if ($('.m-api-ref-section', el).length > 0) {
                hasRefSections[ref] = true;
            }
            if ($('.m-api-docs-sub-section[id]', el).length > 0) {
                hasSubSections[ref] = true;
            }
        });

        (0, _setInterval2['default'])(function () {

            var t;
            var top = w.scrollTop();

            // Check if it has changed before doing anything
            if (currentSection !== null) {
                var r = currentSection.attr('id');
                if (!hasSubSections[r] && !hasRefSections[r]) {
                    t = currentSection.offset().top;
                    if (top >= t && top < t + currentSection.height()) {
                        // No change
                        return;
                    }
                }
            }

            // Reset current selection
            currentSection = null;

            var s;
            var delta = void 0;
            for (var i = 0; i < sections.length; i++) {

                s = $(sections[i]);
                t = s.offset().top;

                if (top >= t && top < t + s.height() && (delta === null || Math.abs(top - t) < delta)) {

                    var ref = s.attr('id');
                    var subs;

                    delta = Math.abs(top - t);
                    currentSection = s;

                    if (hasRefSections[ref] || hasSubSections[ref]) {
                        // Keep going there could be a sub section that's a better match
                        continue;
                    } else {
                        break;
                    }
                }
            }

            if (currentSection !== null) {
                // Update menu
                $(document).trigger('menu_selection_change', { 'ref': currentSection.attr('id') });
            }
        }, interval);
    },

    /**
     * After component mounts, initialize spies
    */
    componentDidMount: function componentDidMount(e) {
        this.startHashSpy(200);
        this.startScrollSpy(100);
        this.startStickinessSpy(100);
    },

    renderApiMenuSections: function renderApiMenuSections(section, i) {
        var isActive = this.state.activeSection && this.state.activeSection.toLowerCase() == section.reference.toLowerCase();
        var isCollapsed = !isActive && section.items && this.state.isCollapsed;

        return _jsx(_section2['default'], {
            title: section.title,
            reference: section.reference,
            url: section.url,
            items: section.items,
            initiallyActiveItem: this.state.activeItem,
            initiallyActiveSubItem: this.state.activeSubItem,
            isInitiallyActive: isActive,
            isInitiallyCollapsed: isCollapsed,
            menuIsFixed: this.state.isFixed
        }, 'section_' + section.reference);
    },

    render: function render() {
        var sections = this.props.sections.map(this.renderApiMenuSections);
        var classes = (0, _classnames2['default'])({
            'l-api-docs-menu': true,
            'is-fixed': this.state.isFixed
        });

        return _react2['default'].createElement(
            'div',
            { ref: 'apiDocMenu', className: classes },
            sections
        );
    }
});

module.exports = ApiMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/index.jsx
 ** module id = 727
 ** module chunks = 0
 **/